$( document ).ready(function() {
    sliderInit();
    
    
  //let productMobileGallery = document.querySelector('.product__media-list.slider');
  //if ($('.product__media-list.slider') && (window.innerWidth < 750)) {
  //  $('.product__media-list.slider').slick({
  //    arrows: false,
  //    dots: true,
  //    slidesToShow: 1.1,
  //    variableWidth: true
  //  })
  //}
    
    $(".disclosure").show();

    $(".section-main-other-info-product .navigation ul li a").click(function(e) {
        e.preventDefault();
        var hrefTag = $(this).attr("href");
        $('html, body').animate({
            scrollTop: $(hrefTag).offset().top-200
        }, 500);
    });

    $(".section-page-instilla-tag-product .tags-filter .tag").click(function() {
        $(".section-page-instilla-tag-product .tags-filter .tag").removeClass("active");
        $(this).addClass("active");
        var tagselected = $(this).data("tag");
        
        $(".block-benefits").each(function() {
            
            if($(this).data("tag")==tagselected) {
                $(this).show();
                $(this).find(".slickslider-tags").slick('unslick');
                $(this).find(".slickslider-tags").slick({
                    infinite:true,
                    arrows : false,
                    centerMode: false,
                    autoplay:false,
                    slidesToShow: 2,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {slidesToShow: 2}
                        },
                        {
                            breakpoint: 768,
                            settings: {slidesToShow: 1}
                        }
                      ]
                });
                var currentSlick = $(this);
                $(this).find(".slickslider-tags").closest(".block-benefits").find("li.next").click(function(e) {
                    e.preventDefault();
                    $(currentSlick).slick('slickNext');
                    return false;
                });
                $(this).find(".slickslider-tags").closest(".block-benefits").find("li.prev").click(function(e) {
                    e.preventDefault();
                    $(currentSlick).slick('slickPrev');
                    return false;
                });
               
                var that = this;
                $(this).find(".slickslider-tags").on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $(that).closest(".section").find(".current-slide").html(nextSlide+1)
                  });
            } else {
                $(this).hide();
            }
        });
            
      });
      var tagFilterCount =0;
      $(".section-page-instilla-tag-product .tags-filter .tag").each(function() {
        
        if(tagFilterCount++==0) {
            $(this).click();
        }
      });
    
      if($(".section-main-other-info-product").length>0) {
        var clone = $(".section-main-other-info-product .navigation").clone();
        $(".sticky-header-extra .page-width").append(clone);
        var clone2 = $(".box-qnt-buy").clone();
        $(".footer-anchor").append(clone2);
        $(".footer-anchor").hide();
      }

      if($(".facets-container-drawer").length>0) {
        /*
        var clone = $(".facets-container-drawer").clone();
        $(".sticky-header-extra .page-width").append(clone);
        $(".sticky-header-extra").addClass("top");
        $(".sticky-header-extra").find(".facets-pill").remove();
        $(".sticky-header-extra").find(".active-facets-mobile").remove();
        $(".sticky-header-extra .mobile-facets__wrapper").after("<div class='title-head'>"+$(".collection-hero__description h2").html()+"</div>");
        */
      }
     
      if($(".starpdp").length>0) {
        setTimeout(function() { loadstar(); }, 1000);
        
        setInterval(function() {
            $(".pricepdp").text("");
            $(".pricepdp").text($(".price-item--regular").first().text());
            $(".pointpdp").text($(".loyalty").text());
            
        }, 1000);
      }

      
      
});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
    if($(".section-main-other-info-product").length>0) {
        var $h1 = $(".section-main-other-info-product #how-to-apply");
        var window_offset = $h1.offset().top - $(window).scrollTop();
        if(window_offset<100) {
            $(".section-main-other-info-product .navigation").fadeOut();
            $(".sticky-header-extra").fadeIn();
            $(".box-qnt-buy-sticky").fadeIn();
        } else {
            $(".section-main-other-info-product .navigation").fadeIn();
            $(".box-qnt-buy-sticky").fadeOut();
            $(".sticky-header-extra").fadeOut();
        }
      if(window_offset<1200 && $(window).width()<800) {
        $(".footer-anchor").fadeIn();
      } else {
        $(".footer-anchor").fadeOut();
      }
    }

    if($(".facets-container-drawer").length>0) {
        var $h1 = $(".facets-wrapper");
        var window_offset = $h1.offset().top - $(window).scrollTop();
        if(window_offset<100) {
            $(".sticky-header-extra").fadeIn();
        } else {
            $(".sticky-header-extra").fadeOut();
        }
    }

    if($(".section-main-other-info-product").length>0) {
        $(".li-float").removeClass("li-active");
        if ($('#how-to-apply').isInViewport()) {
            $(".li-how-to-apply").addClass("li-active");
        } else if ($('#active-ingredients').isInViewport()) {
            $(".li-active-ingredients").addClass("li-active");
        } else if ($('#product-details').isInViewport()) {
            $(".li-product-details").addClass("li-active");
        } else if ($('#active-benefits').isInViewport()) {
            $(".li-active-benefits").addClass("li-active");
        } else if ($('#ssw-widget-recommends-html').isInViewport()) {
            $(".li-ssw-widget-recommends-html").addClass("li-active");
        }
    }
    
    
});

$(window).resize(function(){
    $(".slickslider").each(function() {
        $(this).slick('unslick');
    });
    //$(".slickslider-iconic").slick('unslick');
    reloadInit();
});

function sliderInit() {
    $(".slickslider").each(function() {
        //Retrieve configuration or set dafault
        var autoplay = $(this).data("autoplay");
        var infinite = $(this).data("infinite");
        var speed = $(this).data("speed");
        var fade = $(this).data("fade");
        var cssEase = $(this).data("cssease");
        $(this).slick({
            autoplay:autoplay,
            infinite:infinite,
            speed:speed,
            fade:fade,
            css:cssEase,
            arrows : false,
        });
        var currentSlick = $(this);
        $(this).closest(".section").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        $(this).find(".next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).find(".prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    $(".slickslider-aboutstory").each(function() {
      $(this).slick({
            autoplay:false,
            infinite:false,
            arrows : false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 1
                    }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    
                  }
                }
              ]
        });
        var currentSlick = $(this);
        $(this).closest(".section").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        $(this).find(".next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).find(".prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    $(".slickslider-instagram").each(function() {
        $(this).slick({
              autoplay:false,
              infinite:false,
              arrows : false,
              slidesToShow: 4,
              centerMode: false,
              responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 4
                      }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      
                    }
                  }
                ]
          });
          var currentSlick = $(this);
          $(this).closest(".section").find("li.next").click(function(e) {
              e.preventDefault();
              $(currentSlick).slick('slickNext');
              return false;
          });
          $(this).closest(".section").find("li.prev").click(function(e) {
              e.preventDefault();
              $(currentSlick).slick('slickPrev');
              return false;
          });
          $(this).find(".next").click(function(e) {
              e.preventDefault();
              $(currentSlick).slick('slickNext');
              return false;
          });
          $(this).find(".prev").click(function(e) {
              e.preventDefault();
              $(currentSlick).slick('slickPrev');
              return false;
          });
          var that = this;
          $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $(that).closest(".section").find(".current-slide").html(nextSlide+1)
            });
      });

    $(".slickslider-ingredients").each(function() {
        //Retrieve configuration or set dafault
        var autoplay = $(this).data("autoplay");
        var infinite = $(this).data("infinite");
        var speed = $(this).data("speed");
        var fade = $(this).data("fade");
        var cssEase = $(this).data("cssease");
        $(this).slick({
            autoplay:false,
            infinite:false,
            speed:speed,
            arrows : false,
          
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4
                    }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2
                  }
                }
              ]
        });
        var currentSlick = $(this);
        $(this).closest(".section").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        $(this).find(".next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).find(".prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    

    $(".slickslider-iconic").each(function() {
        //Retrieve configuration or set dafault
      var count = $(this).find(".el").length;
      if(count<=3) {
         $(this).closest(".section-page-instilla-iconic-product").find(".navigation").addClass("hideonmobile");
      }
        $(this).slick({
            infinite:true,
            arrows : false,
            centerMode: (count>3) ? true : false,
            centerPadding: '150px',
            autoplay:false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      arrows: false,
                      centerMode: false,
                      centerPadding: '150px',
                      slidesToShow: 2
                    }
                },
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1
                  }
                }
              ]
        });
        var currentSlick = $(this);
        $(this).closest(".section-page-instilla-iconic-product").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section-page-instilla-iconic-product").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
       
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    $(".slickslider-tags").each(function() {
        //Retrieve configuration or set dafault
        $(this).slick({
            infinite:true,
            arrows : false,
            centerMode: false,
            autoplay:false,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {slidesToShow: 2}
                },
                {
                    breakpoint: 768,
                    settings: {slidesToShow: 1}
                }
              ]
        });
        var currentSlick = $(this);
        $(this).closest(".section-page-instilla-tag-product").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section-page-instilla-tag-product").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
       
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    $(".slickslider-product-detail").each(function() {
        //Retrieve configuration or set dafault
        var slick = $(this).slick({
            infinite:false,
            arrows : false,
            centerMode: false,
            autoplay:false,
            slidesToShow: 1
        });
        var that = this;
        $(this).on('afterChange', function(event, slick, currentSlide, nextSlide){
            $("#product-details ul li").removeClass("active");
            $('#product-details ul').children().eq(currentSlide).addClass("active");
            if (window.innerWidth < 990) {
              let sliderContainer = document.querySelector('#product-details .slick-track');
              sliderContainer.style.height = 'unset';
              setTimeout(function() {
                let slickContainer = document.querySelector('#product-details .slick-slider');
                if (slickContainer) {
                  let slickActive = document.querySelector('#product-details .slick-active');
                  let tabHeight = slickActive ? slickActive.offsetHeight : 0;
                  console.log('ALTEZZA:', tabHeight);
                  if (sliderContainer) {
                    sliderContainer.style.height = tabHeight + 'px';
                  }
                }
              }, 200);
            }
          });
        $("#product-details ul li").click(function() {
            $("#product-details ul li").removeClass("active");
            $(this).addClass("active");
            var slide = $(this).data("slide");
            $(that).slick('slickGoTo', slide);
        });
    });


    $(".slickslider-iconic-collection").each(function() {
        
        //Retrieve configuration or set dafault
        $(this).slick({
            infinite:true,
            arrows : false,
            centerMode: true,
            centerPadding: '140px',
            autoplay:false,
            slidesToShow: 3,
             
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      centerMode: true,
                      centerPadding: '60px',
                    }
                },
                {
                    breakpoint: 768,
                    
                    settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      centerPadding: '60px',
                    }
                }
              ]
            
        });
        var currentSlick = $(this);
        $(this).closest(".section-page-instilla-iconic-product").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section-page-instilla-iconic-product").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
       
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });
    
}

function reloadInit() {
    $(".slickslider").each(function() {
        //Retrieve configuration or set dafault
        var autoplay = $(this).data("autoplay");
        var infinite = $(this).data("infinite");
        var speed = $(this).data("speed");
        var fade = $(this).data("fade");
        var cssEase = $(this).data("cssease");
        $(this).slick({
            autoplay:autoplay,
            infinite:infinite,
            speed:speed,
            fade:fade,
            css:cssEase,
            arrows : false,
        });
        var currentSlick = $(this);
        $(this).closest(".section").find("li.next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).closest(".section").find("li.prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        $(this).find(".next").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickNext');
            return false;
        });
        $(this).find(".prev").click(function(e) {
            e.preventDefault();
            $(currentSlick).slick('slickPrev');
            return false;
        });
        var that = this;
        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(that).closest(".section").find(".current-slide").html(nextSlide+1)
          });
    });

    
}

$(document).ready(function(){

    $(".read-more").click(function(){
        $(".more-text").contents().unwrap().show();
        $(this).remove();
    });

    $(".extreme-container-tab").find(".tab-button").click(function(e) {
        e.preventDefault();
        var target = $(this).data("target");
        $(".extreme-container-tab").find(".tab-button").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").each(function() {
            if($(this).attr("id")==target) {
                $(this).show();
                var found= false;
                $(this).find(".step-button").removeClass("active");
                $(this).find(".step-button").each(function() {
                    if(!found) {
                        $(this).addClass("active");
                        found = true;
                        var target = $(this).data("target");
                        $(".slickslider-tags").each(function() {
                            if($(this).hasClass(target)) {
                                $(this).show();
                                $(this).slick('refresh');
                            } else {
                                $(this).hide();
                            }
                        });
                    }
                });
            } else {
                $(this).hide();
            }
        });
    });
  
   
    if($(".extreme-container-tab").length>0) {
        var found = false;
        $(".step-button").each(function() {
            if(!found) {
                $(this).addClass("active");
                found = true;
                var target = $(this).data("target");
                $(".slickslider-tags").each(function() {
                    if($(this).hasClass(target)) {
                        $(this).show();
                        $(this).slick('refresh');
                    } else {
                        $(this).hide();
                    }
                });
            }
        });
    }
  
    if($(".personal-routine-tab").length>0) {
     $(".personal-routine-tab").find(".step-button").click(function(e) {
        $(this).addClass("active");
        var target = $(this).data("target");
        $(".routine-tab-content").each(function() {
            if($(this).hasClass(target)) {
              $(this).show();
            } else {
              $(this).hide();
            }
        });
      });
    }
  
    $(".step-button").each(function() {
        $(this).click(function() {
            $(".step-button").removeClass("active");
            $(this).addClass("active");
            var target = $(this).data("target");
            $(".slickslider-tags").each(function() {
                if($(this).hasClass(target)) {
                    $(this).show();
                    $(this).slick('refresh');
                } else {
                    $(this).hide();
                }
            });
        });
    });

    $(".box-customer-back").click(function() {
        $(".col-8").hide();
        $(".col-4").show();
        $(".box-customer-back").hide();
    });

    $(".action_address_btn").click(function() {
        var divToShow = $(this).data("controls");
        $("#"+divToShow).show();
        $("#"+divToShow).closest(".box-preview-address").find(".address-header").hide();
        $("#"+divToShow).closest(".box-preview-address").find("section p").hide();
    });
    $(".cancel_address").click(function() {
        $(this).closest(".box-preview-address").find(".address-header").show();
        $(this).closest(".box-preview-address").find("section p").show();
        $(this).closest(".editNew").hide();
    });
    
});


function addtobagpdp() {
    //$(".product-form").find("form").submit();
    $(".product-form").find("button").click();
    e.preventDefault();
}


function loadstar() {
    $(".starpdp").append($("#ssw-avg-rate-profile-html").clone());
    $(".starpdp").find(".ssw-review-count").remove();
    $(".starpdp").find(".ssw-question-count").remove();
    $(".qntpdpcontent").empty();
    $(".qntpdpcontent").append($(".box-qnt-buy").first().clone());
    $(".quantity__button").click(function() {
        var valore = ($(this).closest(".box-qnt-buy").find(".quantity__input").val());
        $(".box-qnt-buy").find(".quantity__input").val(valore);
      });
    
    
}